import React, { useState, useEffect } from "react";
import Select from "react-select";

import { AgGridReact } from "ag-grid-react"; // the AG Grid React Component
import "ag-grid-enterprise";
import CreatableSelect from "react-select/creatable";
import * as _ from "lodash";
import arrowDown from "../../assets/images/arrow-down-white.png";
import arrowUp from "../../assets/images/arrow-up-white.png";
import closeCoss from "../../assets/images/cross-white.png";

import { agGridTheme } from "../../helpers/constants/Constants";
import Modal from "react-bootstrap/Modal";
import makeAnimated from "react-select/animated";
import { AgCharts } from "ag-charts-react";

const CustomFormRenderComp = (props) => {
  const [form, setForm] = useState(props.form);
  //Local Variables
  const inputOptions = [
    { value: "Text Input", label: "Text Input" },
    { value: "Text Area", label: "Text Area" },
    { value: "Date/Time", label: "Date/Time" },
    { value: "Dropdown", label: "Dropdown" },
    { value: "Pass/Fail/NA", label: "Pass/Fail/NA" },
    { value: "Table", label: "Table" },
  ];
  //----------------------
  const animatedComponents = makeAnimated();

  useEffect(() => {
    setForm({ ...props.form }); // Sync local state with props
  }, [props.form]);

  //State
  useEffect(() => {
    let tempInputs = form?.groups
      ?.map((group) => {
        return group.rows.map((row) => {
          return {
            groupId: group.id,
            index: row.index,
            inputValue: "",
          };
        });
      })
      .flat();
    setEditOptionsInputValue(tempInputs);
    setEditGridColumnsInputValue(tempInputs);
  }, [form]);

  const [newInputRow, setNewInputRow] = useState({
    id: null,
    title: null,
    type: inputOptions[0].value,
    options: [],
    multiple: null,
    index: null,
    checklistId: null,
  });
  const [addOptionsInputValue, setAddOptionsInputValue] = useState("");
  const [addColumnsInputValue, setAddColumnsInputValue] = useState("");

  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [itemToDelete, setItemToDelete] = useState(null);
  const [deleteType, setDeleteType] = useState(null);
  const [showExtraActionsModal, setShowExtraActionsModal] = useState(false);
  const [extraActionRow, setExtraActionRow] = useState(false);
  const [extraActionComment, setExtraActionComment] = useState(false);

  //map over every row and create an object with row id and a blank input value
  const [editOptionsInputValue, setEditOptionsInputValue] = useState([]);

  const [editGridColumnsInputValue, setEditGridColumnsInputValue] = useState(
    {},
  );

  //-------------------------

  //------------------------

  const createDropDownValue = (label) => ({
    label,
    value: label,
  });

  const handleKeyDownEditDropDown = (event, row) => {
    var inputValue = editOptionsInputValue?.find(
      (o) => o.index === row.index,
    )?.inputValue;
    if (!inputValue) return;

    switch (event.key) {
      case "Enter":
      case "Tab":
        // setSelectOptionsValue((prev) => [...prev, createOption(selectOptionsInputValue)]);
        var tempEditOptionsInputValue = editOptionsInputValue?.map((o) => {
          if (o.index === row.index) {
            o.inputValue = "";
          }
          return o;
        });
        setEditOptionsInputValue(tempEditOptionsInputValue);

        row.options = [...(row.options ?? []), createDropDownValue(inputValue)];
        event.preventDefault();
        break;
      default:
        break;
    }
  };

  const handleKeyDownAddDropDown = (event, row) => {
    if (!addOptionsInputValue) return;

    switch (event.key) {
      case "Enter":
      case "Tab":
        // setSelectOptionsValue((prev) => [...prev, createOption(selectOptionsInputValue)]);
        setAddOptionsInputValue("");
        row.inputValue = "";
        row.options = [
          ...row.options,
          createDropDownValue(addOptionsInputValue),
        ];
        event.preventDefault();
        break;
      default:
        break;
    }
  };

  const handleKeyDownEditColumns = (event, row) => {
    var inputValue = editGridColumnsInputValue?.find(
      (o) => o.index === row.index,
    )?.inputValue;
    if (!inputValue) return;

    switch (event.key) {
      case "Enter":
      case "Tab":
        // setSelectOptionsValue((prev) => [...prev, createOption(selectOptionsInputValue)]);
        var tempEditColumnsInputValue = editGridColumnsInputValue?.map((o) => {
          if (o.index === row.index) {
            o.inputValue = "";
          }
          return o;
        });
        setEditGridColumnsInputValue(tempEditColumnsInputValue);

        row.gridColumns = [
          ...(row.gridColumns ?? []),
          createDropDownValue(inputValue),
        ];
        event.preventDefault();
        break;
      default:
        break;
    }
  };

  const handleKeyDownAddColumns = (event, row) => {
    if (!addColumnsInputValue) return;
    switch (event.key) {
      case "Enter":
      case "Tab":
        // setSelectOptionsValue((prev) => [...prev, createOption(selectOptionsInputValue)]);
        setAddColumnsInputValue("");
        row.inputValue = "";
        row.gridColumns = [
          ...(row.gridColumns ?? []),
          createDropDownValue(addColumnsInputValue),
        ];
        event.preventDefault();
        break;
      default:
        break;
    }
  };
  //------------------
  // Html Renders -----------------------
  const editButtonsRow = (row) => {
    return (
      <>
        <div className="mt-2 d-flex justify-content-center">
          <div className="col-8 d-flex">
            <input
              className="form-control form-control-sm"
              type="text"
              value={row.label}
              onChange={(e) => {
                props.updateTitle(row, e.target.value);
              }}
            ></input>
          </div>
          <div className="col-4 d-flex">
            <div className="col-12 d-flex">
              <select
                className="form-select form-select-sm"
                id="inputTypeSelect"
                value={row.type}
                onChange={(e) => {
                  props.updateType(row, e.target.value);
                }}
              >
                {inputOptions.map((input) => {
                  return <option title={input.label}>{input.value}</option>;
                })}
              </select>
              <button
                className="btn btn-sm btn-warning"
                onClick={(e) => props.updateIndex("Input", row, -1)}
              >
                <img src={arrowUp} style={{ maxWidth: "20px" }} alt="" />
              </button>
              <button
                className="btn btn-sm btn-warning"
                onClick={(e) => props.updateIndex("Input", row, 1)}
              >
                <img src={arrowDown} style={{ maxWidth: "20px" }} alt="" />
              </button>
              {/* <button className="btn btn-sm btn-danger" onClick={(e) => props.removeRow(row)}> */}
              <button
                className="btn btn-sm btn-danger"
                onClick={(e) => {
                  setItemToDelete(row);
                  setDeleteType("Input");
                  setShowDeleteModal(true);
                }}
              >
                <img src={closeCoss} style={{ maxWidth: "20px" }} alt="" />
              </button>
            </div>
          </div>
        </div>
        {(row.type === "Dropdown") === true && (
          <div className=" d-flex justify-content-center mt-2">
            <div className="col-7">
              <CreatableSelect
                components={animatedComponents}
                inputValue={
                  editOptionsInputValue?.find((o) => o.index === row.index)
                    ?.inputValue
                }
                isClearable
                isMulti
                menuIsOpen={false}
                onChange={(newValue) =>
                  //find the row options in state and update it
                  {
                    var temp = _.clone(form);
                    temp.groups.forEach((group) => {
                      group.rows.forEach((r) => {
                        if (r.index === row.index) {
                          r.options = newValue;
                        }
                      });
                    });
                    setForm(temp);
                  }
                }
                //find the row in editOptionsInputValue and set it to the new value
                onInputChange={(newValue) => {
                  var tempEditOptionsInputValue = editOptionsInputValue.map(
                    (o) => {
                      if (o.index === row.index) {
                        o.inputValue = newValue;
                      }
                      return o;
                    },
                  );
                  setEditOptionsInputValue(tempEditOptionsInputValue);
                }}
                onKeyDown={(e) => handleKeyDownEditDropDown(e, row)}
                placeholder="Type something and press enter..."
                value={row.options}
              />
            </div>
            <div className="col-2">
              <label className="mt-1 ms-1 me-2">Multiple Choice</label>
              <input
                className="form-check-input mt-2"
                type="checkbox"
                // value={markup.markupData[0].actioned}
                id="id"
                onChange={(e) =>
                  setNewInputRow({
                    ...newInputRow,
                    multiple: e.target.value,
                  })
                }
                value={row.multiple}
              />
            </div>
          </div>
        )}

        {(row.type === "Table") === true && (
          <>
            <div className=" d-flex justify-content-center mt-2">
              <div className="col-7">
                <CreatableSelect
                  components={animatedComponents}
                  inputValue={
                    editGridColumnsInputValue?.find(
                      (o) => o.index === row.index,
                    )?.inputValue
                  }
                  isClearable
                  isMulti
                  menuIsOpen={false}
                  onChange={(newValue) =>
                    //find the row gridColumn in state and update it
                    {
                      var temp = _.clone(form);
                      temp.groups.forEach((group) => {
                        group.rows.forEach((r) => {
                          if (r.index === row.index) {
                            r.gridColumns = newValue;
                          }
                        });
                      });
                      setForm(temp);
                    }
                  }
                  onInputChange={(newValue) => {
                    var tempEditGridColumnsInputValue =
                      editGridColumnsInputValue.map((o) => {
                        if (o.index === row.index) {
                          o.inputValue = newValue;
                        }
                        return o;
                      });
                    setEditGridColumnsInputValue(tempEditGridColumnsInputValue);
                  }}
                  onKeyDown={(e) => handleKeyDownEditColumns(e, row)}
                  placeholder="Type something and press enter..."
                  value={row.gridColumns}
                />
              </div>
              <div className="row g-3 align-items-center ms-2">
                <div className="col-auto">
                  <label className="col-form-label">Rows</label>
                </div>
                <div className="col-auto">
                  <input
                    type="number"
                    className="form-control form-control-sm"
                    aria-describedby="passwordHelpInline"
                    value={row.gridRows.length}
                    onChange={(e) => {
                      const newRowCount = parseInt(e.target.value, 10) || 0;

                      // Create a new array for gridRows, retaining existing data where possible
                      const newGridRows = Array.from(
                        { length: newRowCount },
                        (_, index) => {
                          return row.gridRows[index] || {}; // Retain existing row data if it exists, otherwise create an empty object
                        },
                      );

                      // Update the row object with a new reference
                      const updatedRow = { ...row, gridRows: newGridRows };

                      // Update the form state with the updated row
                      const updatedForm = _.cloneDeep(form);
                      updatedForm.groups.forEach((group) => {
                        group.rows = group.rows.map((r) =>
                          r.index === row.index ? updatedRow : r,
                        );
                      });

                      setForm(updatedForm); // Trigger a re-render
                    }}
                  />
                </div>
              </div>
            </div>
            {/* 2 Dropdowns to select the X and Y axis columns for a graph to be rendered */}
            <div className="d-flex justify-content-center mt-2">
              <div className="col-4">
                <label className="">X Axis</label>
              </div>
              <div className="col-4">
                <label className="">Y Axis</label>
              </div>
              <div className="col-4">
                <label className="">Trendline</label>
              </div>
            </div>
            <div className=" d-flex justify-content-center mt-2">
              <div className="col-4">
                <Select
                  isClearable
                  options={row.gridColumns}
                  onChange={(e) => {
                    row.graph = { ...row.graph, xAxis: e?.value ?? null };
                  }}
                  value={{
                    value: row.graph?.xAxis,
                    label: row.graph?.xAxis,
                  }}
                />
              </div>
              <div className="col-4">
                <Select
                  isClearable
                  options={row.gridColumns}
                  onChange={(e) => {
                    row.graph = { ...row.graph, yAxis: e?.value ?? null };
                  }}
                  value={{
                    value: row.graph?.yAxis,
                    label: row.graph?.yAxis,
                  }}
                />
              </div>
              {/* text input to give a trendline */}
              <div className="col-4">
                <input
                  className="form-control form-control-sm mt-1"
                  type="text"
                  value={row.graph?.trendline}
                  onChange={(e) => {
                    row.graph = {
                      ...row.graph,
                      trendline: e.target?.value ?? null,
                    };
                  }}
                ></input>
              </div>
            </div>

            {/* Ag Grid using the gridColumns */}
            <div className="col-12 mt-2">
              <div style={{ height: 400, width: "100%" }}>
                <AgGridReact
                  theme={agGridTheme}
                  columnDefs={row.gridColumns?.map((column) => {
                    return {
                      headerName: column.label,
                      field: column.value,
                      editable: true,
                      cellEditor: "agNumberCellEditor",
                    };
                  })}
                  rowData={row.gridRows}
                  // gridOptions={agGridOptions}
                />
              </div>
            </div>
          </>
        )}
      </>
    );
  };
  const editButtonsGroup = (group) => {
    return (
      <div className="ps-2 pb-2 mt-2 d-flex">
        <div className="col-4 d-flex">
          <input
            className="form-control form-control-sm"
            type="text"
            value={group.name}
            onChange={(e) => {
              props.updateName(group, e.target.value);
            }}
          ></input>
        </div>
        <div className="col-4 d-flex">
          <div className="col-12 d-flex">
            <button
              className="btn btn-sm btn-warning"
              onClick={(e) => props.updateIndex("Group", group, -1)}
            >
              <img src={arrowUp} style={{ maxWidth: "20px" }} alt="" />
            </button>
            <button
              className="btn btn-sm btn-warning"
              onClick={(e) => props.updateIndex("Group", group, 1)}
            >
              <img src={arrowDown} style={{ maxWidth: "20px" }} alt="" />
            </button>
            {/* <button className="btn btn-sm btn-danger" onClick={(e) => props.removeRow(row)}> */}
            <button
              className="btn btn-sm btn-danger"
              onClick={(e) => {
                setItemToDelete(group);
                setDeleteType("Group");
                setShowDeleteModal(true);
              }}
            >
              <img src={closeCoss} style={{ maxWidth: "20px" }} alt="" />
            </button>
          </div>
        </div>
      </div>
    );
  };

  const threeButtons = (row, confirm, decline) => {
    return (
      <>
        <div className="d-flex justify-content-between">
          <label className="col-form-label col-form-label-sm ">
            {row.label}
          </label>
          <div className="d-flex align-items-center">
            <div
              id={row.label + "group"}
              className="btn-group btn-group-sm"
              role="group"
              aria-label="Basic radio toggle button group"
            >
              {
                // if viewMode add the Checked Field
                props.viewMode && (
                  <input
                    type="radio"
                    className="btn-check"
                    name={row.label + "group"}
                    id={row.label + confirm}
                    autoComplete="off"
                    value={confirm}
                    key={row.value + confirm}
                    disabled={props.editMode || props.viewMode}
                    checked={row.response === confirm || row.value === confirm}
                  />
                )
              }
              {!props.viewMode && (
                <input
                  type="radio"
                  className="btn-check"
                  name={row.label + "group"}
                  id={row.label + confirm}
                  autoComplete="off"
                  value={confirm}
                  key={row.value + confirm}
                  disabled={props.editMode || props.viewMode}
                  onChange={(e) => {
                    row.value = e.target.value;
                  }}
                />
              )}
              {
                // if viewMode add the Checked Field
                props.viewMode && (
                  <input
                    type="radio"
                    className="btn-check"
                    name={row.label + "group"}
                    id={row.label + decline}
                    autoComplete="off"
                    value={decline}
                    key={row.value + decline}
                    disabled={props.editMode || props.viewMode}
                    checked={row.response === decline || row.value === decline}
                  />
                )
              }
              <label
                className="btn btn-outline-success"
                htmlFor={row.label + confirm}
              >
                {confirm}
              </label>
              {!props.viewMode && (
                <input
                  type="radio"
                  className="btn-check"
                  name={row.label + "group"}
                  id={row.label + decline}
                  autoComplete="off"
                  key={row.value + decline}
                  value={decline}
                  disabled={props.editMode || props.viewMode}
                  onChange={(e) => {
                    row.value = e.target.value;
                  }}
                />
              )}
              <label
                className="btn btn-outline-danger"
                htmlFor={row.label + decline}
              >
                {decline}
              </label>
              {
                // if viewMode add the Checked Field
                props.viewMode && (
                  <input
                    type="radio"
                    className="btn-check"
                    name={row.label + "group"}
                    id={row.label + "NA"}
                    autoComplete="off"
                    value="NA"
                    key={row.value + "NA"}
                    disabled={props.editMode || props.viewMode}
                    checked={row.response === "NA" || row.value === "NA"}
                    onChange={(e) => {
                      row.value = e.target.value;
                    }}
                  />
                )
              }
              {
                // if viewMode add the Checked Field
                !props.viewMode && (
                  <input
                    type="radio"
                    className="btn-check"
                    name={row.label + "group"}
                    id={row.label + "NA"}
                    autoComplete="off"
                    value="NA"
                    key={row.value + "NA"}
                    disabled={props.editMode || props.viewMode}
                    onChange={(e) => {
                      row.value = e.target.value;
                    }}
                  />
                )
              }
              <label
                className="btn btn-outline-info"
                htmlFor={row.label + "NA"}
              >
                NA
              </label>
            </div>
            <button
              className="btn btn-sm btn-outline-info ms-2"
              onClick={(e) => {
                setExtraActionRow(row);
                setExtraActionComment(row.comment);
                setShowExtraActionsModal(true);
              }}
            >
              +
            </button>
          </div>
        </div>
      </>
    );
  };

  const inputRow = (row) => {
    let inputRow = <></>;
    let extraButtons = (
      <button
        className="btn btn-sm btn-outline-info"
        onClick={(e) => {
          setExtraActionRow(row);
          setExtraActionComment(row.comment);
          setShowExtraActionsModal(true);
        }}
      >
        +
      </button>
    );
    switch (row.type) {
      case "Text Input":
        inputRow = (
          <>
            <label className="col-form-label col-form-label-sm fw-bold">
              {row.label}
            </label>
            <div className="input-group mb-3">
              <input
                className="form-control form-control-sm"
                type="text"
                disabled={props.editMode || props.viewMode}
                value={row.response}
                onChange={(e) => {
                  row.value = e.target.value;
                }}
              ></input>
              {extraButtons}
            </div>
          </>
        );
        break;
      case "Date/Time":
        inputRow = (
          <>
            <label className="col-form-label col-form-label-sm fw-bold">
              {row.label}
            </label>
            <input
              className="form-control form-control-sm"
              type="date"
              disabled={props.editMode || props.viewMode}
              onChange={(e) => {
                row.value = e.target.value;
              }}
            ></input>
          </>
        );
        break;
      case "Text Area":
        inputRow = (
          <>
            <label className="col-form-label col-form-label-sm fw-bold">
              {row.label} Text Area
            </label>
            <textarea
              className="form-control form-control-sm"
              type="date"
              disabled={props.editMode || props.viewMode}
              onChange={(e) => {
                row.value = e.target.value;
              }}
            ></textarea>
          </>
        );
        break;
      case "Dropdown":
        inputRow = (
          <>
            <label className="col-form-label col-form-label-sm fw-bold">
              {row.label}
            </label>
            <Select
              isMulti={row.multiple}
              name="roles"
              options={row.options}
              className="basic-multi-select"
              classNamePrefix="select"
              onChange={(e) => {
                row.value = e.value;
              }}
              disabled={props.editMode || props.viewMode}
            />
          </>
        );
        break;
      case "Table":
        inputRow = (
          <>
            <label className="col-form-label col-form-label-sm fw-bold">
              {row.label}
            </label>
            {/* AG Grid with rowData and rowColumns */}
            <div className="col-12">
              <div style={{ height: 400, width: "100%" }}>
                <AgGridReact
                  theme={agGridTheme}
                  columnDefs={row.gridColumns?.map((column) => {
                    return {
                      headerName: column.label,
                      field: column.value,
                      //Editable if the row does not already contain a value
                      editable: !row.gridRows.some((r) => r[column.value]),
                      cellEditor: "agNumberCellEditor",
                    };
                  })}
                  rowData={row.gridRows}
                />
              </div>
            </div>
          </>
        );
        break;
      case "Pass/Fail/NA":
        inputRow = threeButtons(row, "Pass", "Fail");
        break;
      case "Yes/No/NA":
        inputRow = threeButtons(row, "Yes", "No");
        break;
      case "True/False/NA":
        inputRow = threeButtons(row, "True", "False");
        break;
      default:
        break;
    }
    return inputRow;
  };

  return (
    <>
      {/* Modal to add comment to input form */}
      <Modal
        show={showExtraActionsModal}
        onHide={(e) => {
          setShowExtraActionsModal(false);
        }}
      >
        <Modal.Header closeButton>
          <Modal.Title>Add Comment</Modal.Title>
          <div
            data-bs-theme="dark"
            style={{
              position: "absolute",
              right: 20,
            }}
          >
            <button
              type="button"
              className="btn-close"
              onClick={(e) => {
                setShowExtraActionsModal(false);
              }}
              aria-label="Close"
            />
          </div>
        </Modal.Header>
        <Modal.Body>
          <label className="col-form-label col-form-label-sm fw-bold">
            {extraActionRow?.label}
          </label>
          <textarea
            className="form-control form-control-sm"
            type="text"
            disabled={props.editMode || props.viewMode}
            value={extraActionComment}
            onChange={(e) => {
              setExtraActionComment(e.target.value);
            }}
          ></textarea>
          <div className="d-flex justify-content-end p-1">
            <button
              className="btn btn-secondary btn-sm"
              onClick={(e) => {
                setShowExtraActionsModal(false);
              }}
            >
              Cancel
            </button>
            <button
              className="btn btn-success btn-sm"
              onClick={(e) => {
                //find the row in props.rows and update the comment
                form.groups.forEach((group) => {
                  group.rows.forEach((row) => {
                    if (row.id === extraActionRow.id) {
                      //row.comment = a copy of the comment
                      row.comment = extraActionComment;
                    }
                  });
                });

                setShowExtraActionsModal(false);
              }}
            >
              Add
            </button>
          </div>
        </Modal.Body>
      </Modal>

      <Modal
        show={showDeleteModal}
        onHide={(e) => {
          setShowDeleteModal(false);
        }}
      >
        <Modal.Header closeButton>
          <Modal.Title>Confirm Delete</Modal.Title>
          <div
            data-bs-theme="dark"
            style={{
              position: "absolute",
              right: 20,
            }}
          >
            <button
              type="button"
              className="btn-close"
              onClick={(e) => {
                setShowDeleteModal(false);
              }}
              aria-label="Close"
            />
          </div>
        </Modal.Header>
        <Modal.Body>
          Are you sure you want to delete this {deleteType}:{" "}
          {deleteType === "Group" ? itemToDelete?.name : itemToDelete?.label}?
          <div className="d-flex justify-content-end p-1">
            <button
              className="btn btn-secondary btn-sm"
              onClick={(e) => {
                setShowDeleteModal(false);
              }}
            >
              Cancel
            </button>
            <button
              className="btn btn-danger btn-sm"
              onClick={(e) => {
                switch (deleteType) {
                  case "Group":
                    props.removeGroup(itemToDelete);
                    break;
                  case "Input":
                    props.removeRow(itemToDelete);
                    break;
                  default:
                    break;
                }
                setShowDeleteModal(false);
              }}
            >
              Delete
            </button>
          </div>
        </Modal.Body>
      </Modal>

      <div>
        {form?.groups
          ?.filter(
            (group) => props.editMode || (group.rows && group.rows.length > 0),
          )
          ?.sort((a, b) => (a.index > b.index ? 1 : -1))
          .map((group) => {
            return (
              <div key={group.id} className="d-flex justify-content-center">
                <div
                  className="accordion col-12 col-lg-8"
                  id={group.id + "accordion"}
                  key={group.id}
                >
                  <div className="accordion-item">
                    {/* Group Header */}

                    <h2 className="accordion-header" id="headingOne">
                      {props.editMode && editButtonsGroup(group)}
                      <button
                        className="accordion-button"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target={"#group" + group.id}
                        aria-expanded="true"
                        aria-controls={"group" + group.id}
                      >
                        {group.name}
                      </button>
                    </h2>
                    {/* Group Body */}
                    <div
                      id={"group" + group.id}
                      className="accordion-collapse collapse show"
                      aria-labelledby="headingOne"
                      data-bs-parent={"#" + group.id + "accordion"}
                    >
                      <div className="accordion-body">
                        <div>
                          {group.rows
                            .sort((a, b) => (a.index > b.index ? 1 : -1))
                            .map((row, index) => {
                              // All Input Types
                              let tempHtml = inputRow(row);

                              //Edit Mode and View Mode
                              if (props.editMode && props.viewMode) {
                                return (
                                  <div key={row.id}>
                                    <label className="col-form-label col-form-label-sm fw-bold">
                                      {row.label}
                                    </label>
                                    {row.response}
                                  </div>
                                );
                              }
                              //Edit Mode and not View Mode
                              if (props.editMode && !props.viewMode) {
                                return (
                                  <div key={row.id}>{editButtonsRow(row)}</div>
                                );
                              }

                              if (props.viewMode) {
                                return (
                                  <div key={row.id}>
                                    <div className="mt-2 d-flex justify-content-center">
                                      <div className="col-6">
                                        <label className="col-form-label col-form-label-sm fw-bold">
                                          {row.label}
                                        </label>
                                      </div>
                                      <div className="col-6">
                                        {row.type !== "Table" && row.response}
                                      </div>
                                    </div>
                                    {row.comment && (
                                      <div className="mt-2 d-flex justify-content-center">
                                        <div className="col-6">
                                          <label className="col-form-label col-form-label-sm">
                                            Comment
                                          </label>
                                        </div>
                                        <div className="col-6">
                                          {row.comment}
                                        </div>
                                      </div>
                                    )}
                                    {/* If row.type is table render agGrid */}
                                    {row.type === "Table" && (
                                      <div className="col-12">
                                        <div
                                          style={{ height: 400, width: "100%" }}
                                        >
                                          <AgGridReact
                                            theme={agGridTheme}
                                            //Loop over all the row response data and extract the keys to create the columnDefs
                                            columnDefs={Object.keys(
                                              JSON.parse(row.response)[0],
                                            ).map((column) => {
                                              return {
                                                headerName: column,
                                                field: column,
                                                editable: false,
                                                cellEditor:
                                                  "agNumberCellEditor",
                                              };
                                            })}
                                            //Json serialized data
                                            rowData={JSON.parse(row.response)}
                                          />
                                        </div>
                                      </div>
                                    )}
                                    {/* if the row has a graph render the graph */}
                                    {row.graph !== null && (
                                      <AgCharts
                                        options={{
                                          // Data: Data to be displayed in the chart
                                          data: JSON.parse(row.response).map(
                                            (r) => {
                                              return {
                                                ...r,
                                                //pull the equation from the row.graph.trendline and subsitute the x value
                                                // eslint-disable-next-line no-eval
                                                trendLine: eval(
                                                  row.graph.trendline.replace(
                                                    "x",
                                                    "*" + r[row.graph.xAxis],
                                                  ),
                                                ),
                                              };
                                            },
                                          ),
                                          axes: [
                                            {
                                              type: "category", // category | grouped-category | number | log | time | ordinal-time
                                              position: "bottom", // top | right | bottom | left
                                              title: {
                                                text: row.graph.xAxis,
                                              },
                                            },
                                            {
                                              type: "number", // category | grouped-category | number | log | time | ordinal-time
                                              position: "left", // top | right | bottom | left
                                              interval: { step: 100 },
                                              title: {
                                                text: row.graph.yAxis,
                                              },
                                            },
                                          ],
                                          // Series: Defines which chart type and data to use
                                          series: [
                                            {
                                              type: "line",
                                              xKey: row.graph.xAxis,
                                              yKey: row.graph.yAxis,
                                              yName: row.graph.yAxis,
                                            },
                                            {
                                              type: "line",
                                              xKey: row.graph.xAxis,
                                              yKey: "trendLine",
                                              yName: row.graph.trendline,
                                            },
                                          ],
                                        }}
                                      />
                                    )}
                                  </div>
                                );
                              }
                              if (!props.viewMode) {
                                return (
                                  <div key={row.id}>
                                    {/* Record Mode allow user to record input */}
                                    {!props.viewMode && (
                                      <div className="mt-3">
                                        {/* {tempHtml} */}
                                        {/* TempHtml and a button to trigger a modal to add a comment */}
                                        {tempHtml}

                                        {row.comment && (
                                          <div>
                                            <label className="col-form-label col-form-label-sm">
                                              Comment
                                            </label>
                                            <p>{row.comment}</p>
                                          </div>
                                        )}
                                        {/* {props.editMode && editButtons(row)} */}
                                        {index !== group.rows.length - 1 && (
                                          <hr />
                                        )}
                                      </div>
                                    )}
                                  </div>
                                );
                              }

                              return null;
                            })}
                        </div>
                        {/* Add To Form Form */}
                        {props.editMode === true && (
                          <>
                            <hr />
                            <div className="col-12">
                              <div className="mt-4 d-flex justify-content-center">
                                {/* Add Row */}
                                <div className="col-3">
                                  <input
                                    type="text"
                                    className="form-control form-control-sm"
                                    id="title"
                                    placeholder="Title"
                                    onChange={(e) =>
                                      setNewInputRow({
                                        ...newInputRow,
                                        label: e.target.value,
                                      })
                                    }
                                  />
                                </div>
                                <div className="col-4">
                                  {/* Using Select component lead to problems with styling */}
                                  {/* <Select
                      name="roles"
                      options={inputOptions}
                      className="basic-multi-select"
                      classNamePrefix="select"
                      onChange={(e) =>
                        setNewInputRow({ ...newInputRow, type: e.value })
                      }
                    /> */}

                                  <select
                                    className="form-select form-select-sm"
                                    id="inputTypeSelect"
                                    onChange={(e) =>
                                      setNewInputRow({
                                        ...newInputRow,
                                        type: e.target.value,
                                      })
                                    }
                                  >
                                    {inputOptions.map((input) => {
                                      return (
                                        <option title={input.label}>
                                          {input.value}
                                        </option>
                                      );
                                    })}
                                  </select>
                                </div>

                                <div className="col-1">
                                  <button
                                    className="btn btn-sm btn-success btn-block"
                                    onClick={(e) =>
                                      props.addInputToFormRows(
                                        group.id,
                                        newInputRow,
                                      )
                                    }
                                  >
                                    Add
                                  </button>
                                </div>
                              </div>
                            </div>
                            {(newInputRow.type === "Dropdown") === true && (
                              <div className=" d-flex justify-content-center mt-2">
                                <div className="col-7">
                                  <CreatableSelect
                                    components={animatedComponents}
                                    inputValue={addOptionsInputValue}
                                    isClearable
                                    isMulti
                                    menuIsOpen={false}
                                    onChange={(newValue) =>
                                      setNewInputRow({
                                        ...newInputRow,
                                        options: newValue,
                                      })
                                    }
                                    onInputChange={(newValue) =>
                                      setAddOptionsInputValue(newValue)
                                    }
                                    onKeyDown={(e) =>
                                      handleKeyDownAddDropDown(e, newInputRow)
                                    }
                                    placeholder="Type something and press enter..."
                                    value={newInputRow.options}
                                  />
                                </div>
                                <div className="col-2">
                                  <label className="mt-1 ms-1 me-2">
                                    Multiple Choice
                                  </label>
                                  <input
                                    className="form-check-input mt-2"
                                    type="checkbox"
                                    // value={markup.markupData[0].actioned}
                                    id="id"
                                    onChange={(e) =>
                                      setNewInputRow({
                                        ...newInputRow,
                                        multiple: e.target.value,
                                      })
                                    }
                                  />
                                </div>
                              </div>
                            )}
                            {(newInputRow.type === "Table") === true && (
                              <div className=" d-flex justify-content-center mt-2">
                                <div className="col-5">
                                  <CreatableSelect
                                    components={animatedComponents}
                                    inputValue={addColumnsInputValue}
                                    isClearable
                                    isMulti
                                    menuIsOpen={false}
                                    onChange={(newValue) =>
                                      setNewInputRow({
                                        ...newInputRow,
                                        gridColumns: newValue,
                                      })
                                    }
                                    onInputChange={(newValue) =>
                                      setAddColumnsInputValue(newValue)
                                    }
                                    onKeyDown={(e) =>
                                      handleKeyDownAddColumns(e, newInputRow)
                                    }
                                    placeholder="Type something and press enter..."
                                    value={newInputRow.gridColumns}
                                  />
                                </div>
                                <div className="row g-3 align-items-center ms-2">
                                  <div className="col-auto">
                                    <label className="col-form-label">
                                      Rows
                                    </label>
                                  </div>
                                  <div className="col-auto">
                                    <input
                                      type="number"
                                      className="form-control form-control-sm"
                                      aria-describedby="passwordHelpInline"
                                      onChange={(e) => {
                                        //loop over the number of rows and add an empty row into grid rows
                                        newInputRow.gridRows = [];
                                        for (
                                          let i = 0;
                                          i < e.target.value;
                                          i++
                                        ) {
                                          newInputRow.gridRows.push({});
                                        }
                                      }}
                                    />
                                  </div>
                                </div>
                              </div>
                            )}
                          </>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            );
          })}
      </div>
      {/* If edit mode allow add group */}
      {props.editMode && (
        <div className="d-flex justify-content-center mt-2">
          <button
            className="btn btn-sm btn-success  col-4"
            onClick={() => props.addNewGroup()}
          >
            Add Group
          </button>
        </div>
      )}
    </>
  );
};

export default CustomFormRenderComp;
